import { render, staticRenderFns } from "./choydar.vue?vue&type=template&id=1a27f2ae&scoped=true&"
import script from "./choydar.vue?vue&type=script&lang=js&"
export * from "./choydar.vue?vue&type=script&lang=js&"
import style0 from "./choydar.vue?vue&type=style&index=0&id=1a27f2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27f2ae",
  null
  
)

export default component.exports